import ShortVideoRepository from './ShortVideoRepository'
import SettingRepository from './SettingRepository'
export default ($axios) => ({
	shortVideo: ShortVideoRepository($axios),
	setting: SettingRepository($axios)
})